export default "__VITE_ASSET__CuKSFXz8__"